import Controller from '@ember/controller';
import { action, computed, set } from '@ember/object';
import { service } from '@ember/service';

export default class IntervarsityProspectsIndexController extends Controller {
  @service router;

  @computed('model.selectedFile')
  get invalidFileExtension() {
    if (this.model.selectedFile) {
      return /\.xlsx$/.test(this.model.selectedFile.name) === false;
    } else {
      return false;
    }
  }

  @action
  selectFile(file) {
    set(this, 'model.selectedFile', file);
  }

  @action
  startUpload() {
    if (this.model.selectedFile == null || this.invalidFileExtension) {
      alert('Please select a file before you start the upload.');
    } else {
      this.router.transitionTo(
        'funds.fund.import.intervarsity-prospects.processing',
      );
    }
  }
}
